import React, { Fragment } from 'react';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { BlockPlaceholder } from "../../components/elements/BlockPlaceholder";
import { Divider } from "../../components/elements/Divider";
import { TextPlaceholder } from "../../components/elements/TextPlaceholder";
export var getCardPlaceholderMarkup = function getCardPlaceholderMarkup() {
  return React.createElement(Fragment, null, React.createElement(BlockPlaceholder, {
    isRectangular: true
  }), React.createElement(Card.Content, null, React.createElement(Card.Header, null, React.createElement(Divider, {
    size: "small"
  }), React.createElement(TextPlaceholder, {
    length: "medium"
  }), React.createElement(TextPlaceholder, {
    length: "long"
  }), React.createElement(TextPlaceholder, {
    length: "long"
  }))));
};